<template>
	<div class="allback">
		<div class="zy_content content-nav">
			<img src="@/images/nav_img.png" />
			<span>个人中心</span>
		</div>
		<el-container class="content">
			<div class=" zy_content clearfix">
				<div class="zy_index_title">
					<img src="@/images/title_back1.png" class="zy_index_titleback" />
					<img src="@/images/zy-title1.png" class="zy_index_titlename" />
				</div>
				<div class="zy_maincont clearfix">
					<div class="per_content clearfix">
						<div class="per_left">
							<div class="per_left_top">
								<img :src="baseurl + userinfo.iconurl" v-if="userinfo.iconurl" class="centerhead" />
								<img src="@/images/headportrait.png" v-if="!userinfo.iconurl" class="centerhead" />
								<p class="per_p_1">
									{{userinfo.name}}
								</p>
								<p class="per_p_2">
									{{userinfo.deptName || '暂无班级信息'}}
								</p>
							</div>
							<div class="per_left_bottom">
								<div class="center_tab_pane" :class="activeTab == item.value?'active':''" @click="activeTab = item.value" v-for="(item,index) in menus">
									<img src="@/images/center_choose.png" class="center_choose back" />
									<img src="@/images/center_choosed.png" class="center_choosed back" />
									<div class="center_tab_paneinfo">
										<img src="@/images/centernew1.png" class="center_choose" v-if="index == 0" />
										<img src="@/images/centernew1_a.png" class="center_choosed" v-if="index == 0" />
										<img src="@/images/centernew3.png" class="center_choose" v-if="index == 1" />
										<img src="@/images/centernew3_a.png" class="center_choosed" v-if="index == 1" />
										<img src="@/images/centernew4.png" class="center_choose" v-if="index == 2" />
										<img src="@/images/centernew4_a.png" class="center_choosed" v-if="index == 2" />
										<img src="@/images/centernew9.png" class="center_choose" v-if="index == 3" />
										<img src="@/images/centernew9_a.png" class="center_choosed" v-if="index == 3" />
										<img src="@/images/centernew12.png" class="center_choose" v-if="index == 4" />
										<img src="@/images/centernew12_a.png" class="center_choosed" v-if="index == 4" />
										<img src="@/images/centernew5.png" class="center_choose" v-if="index == 5" />
										<img src="@/images/centernew5_a.png" class="center_choosed" v-if="index == 5" />
										<img src="@/images/centernew10.png" class="center_choose" v-if="index == 6" />
										<img src="@/images/centernew10_a.png" class="center_choosed" v-if="index == 6" />
										<img src="@/images/centernew6.png" class="center_choose" v-if="index == 7" />
										<img src="@/images/centernew6_a.png" class="center_choosed" v-if="index == 7" />
										<img src="@/images/centernew7.png" class="center_choose" v-if="index == 8" />
										<img src="@/images/centernew7_a.png" class="center_choosed" v-if="index == 8" />
										<img src="@/images/centernew8.png" class="center_choose" v-if="index == 9" />
										<img src="@/images/centernew8_a.png" class="center_choosed" v-if="index == 9" />
										<img src="@/images/centernew11.png" class="center_choose" v-if="index == 10" />
										<img src="@/images/centernew11_a.png" class="center_choosed" v-if="index == 10" />
										<img src="@/images/centernew12.png" class="center_choose" v-if="index == 11" />
										<img src="@/images/centernew12_a.png" class="center_choosed" v-if="index == 11" />
										<img src="@/images/centernew13.png" class="center_choose" v-if="index == 12" />
										<img src="@/images/centernew13_a.png" class="center_choosed" v-if="index == 12" />
										<img src="@/images/centernew4.png" class="center_choose" v-if="index == 13" />
										<img src="@/images/centernew4_a.png" class="center_choosed" v-if="index == 13" />
										<img src="@/images/centernew2.png" class="center_choose" v-if="index == 14" />
										<img src="@/images/centernew2_a.png" class="center_choosed" v-if="index == 14" />
										<span>{{item.name}}</span>
									</div>
								</div>
							</div>
						</div>
						<center-personal v-if="activeTab == '1'" :majorid='majorid'></center-personal>
						<center-examination v-if="activeTab == '2'" :majorid='majorid'></center-examination>
						<center-task v-if="activeTab == '3'" :majorid='majorid'></center-task>
						<center-test v-if="activeTab == '4'" :majorid='majorid'></center-test>
						<center-error v-if="activeTab == '5'" :majorid='majorid'></center-error>
						<center-note v-if="activeTab == '6'" :majorid='majorid'></center-note>
						<center-interaction v-if="activeTab == '7'" :majorid='majorid'></center-interaction>
						<center-news v-if="activeTab == '8'" :majorid='majorid'></center-news>
						<center-post v-if="activeTab == '9'" :majorid='majorid'></center-post>
						<center-feedback v-if="activeTab == '10'" :majorid='majorid'></center-feedback>
						<center-collection v-if="activeTab == '11'" :majorid='majorid'></center-collection>
						<center-representate v-if="activeTab == '12'" :majorid='majorid'></center-representate>
						<center-statistical v-if="activeTab == '13'" :majorid='majorid'></center-statistical>
						<center-comment v-if="activeTab == '14'" :majorid='majorid'></center-comment>
						<center-password v-if="activeTab == '15'" :majorid='majorid'></center-password>
					</div>
				</div>
			</div>
		</el-container>
	</div>
</template>

<script>
	import { getInfo } from '@/api/user.js'
	import centerPersonal from "@/views/center/centerPersonal.vue"
	import centerExamination from "@/views/center/centerExamination.vue"
	import centerTask from "@/views/center/centerTask.vue"
	import centerTest from "@/views/center/centerTest.vue"
	import centerError from "@/views/center/centerError.vue"
	import centerNote from "@/views/center/centerNote.vue"
	import centerInteraction from "@/views/center/centerInteraction.vue"
	import centerNews from "@/views/center/centerNews.vue"
	import centerPost from "@/views/center/centerPost.vue"
	import centerFeedback from "@/views/center/centerFeedback.vue"
	import centerCollection from "@/views/center/centerCollection.vue"
	import centerRepresentate from "@/views/center/centerRepresentate.vue"
	import centerStatistical from "@/views/center/centerStatistical.vue"
	import centerComment from "@/views/center/centerComment.vue"
	import centerPassword from "@/views/center/centerPassword.vue"
	export default {
		components: {
			centerPersonal,
			centerExamination,
			centerTask,
			centerTest,
			centerError,
			centerNote,
			centerInteraction,
			centerNews,
			centerPost,
			centerFeedback,
			centerCollection,
			centerRepresentate,
			centerStatistical,
			centerComment,
			centerPassword,
		},
		data() {
			return {
				userinfo: {},
				menus: [{
					name: '个人信息',
					value: '1',
				}, {
					name: '我的考试',
					value: '2',
				}, {
					name: '我的作业',
					value: '3',
				}, {
					name: '我的自测',
					value: '4',
				}, {
					name: '我的错题',
					value: '5',
				}, {
					name: '学习笔记',
					value: '6',
				}, {
					name: '互动试题',
					value: '7',
				}, {
					name: '我的消息',
					value: '8',
				}, {
					name: '我的帖子',
					value: '9',
				}, {
					name: '我的反馈',
					value: '10',
				}, {
					name: '我的收藏',
					value: '11',
				}, {
					name: '我的申诉',
					value: '12',
				}, {
					name: '我的统计',
					value: '13',
				}, {
					name: '教师评语',
					value: '14',
				}, {
					name: '修改密码',
					value: '15',
				}],
				tabPosition: 'left',
				activeTab: '1',
				majorid: this.majorIdForAll,
			};
		},
		created() {
			var activeTab = this.$route.query.activeTab;
			if(!activeTab) {
				activeTab = 1
			}
			this.catchType(activeTab)
			this.getMyInfo();
		},
		methods: {
			getMyInfo() {
				getInfo().then(res => {
					this.userinfo = res.data;
				})
			},
			catchType(activeTab) {
				if(activeTab && activeTab != '-1') {
					activeTab = Number(activeTab);
					if(!isNaN(activeTab) && activeTab % 1 == 0) {
						this.activeTab = activeTab.toString();
					} else {
						this.activeTab = '1';
					}
				} else {
					this.activeTab = '1';
				}
			},
		}
	}
</script>

<style>

</style>